import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import 'static/script/app/ui/search-suggestion';

function SiteSearch() {

    this._initData = null;
    this._lastQuery = null;

    var KEYCODE_ENTER = 13;
    var KEYCODE_ESC = 27;
    var KEYCODE_UP = 38;
    var KEYCODE_DOWN = 40;
    var FORM_ELEMENT_FOCUS = 'form-element-focus';

    var NAVIGATION_KEY_CODES = [KEYCODE_DOWN, KEYCODE_UP, KEYCODE_ENTER, KEYCODE_ESC];

    var selectedShopUrl;

    this.defaultAttrs({
        searchFieldArea: '[data-site-header-search-field]',
        searchFieldClear: '[data-site-header-search-field-clear]',
        searchSubmitButtonSelector: '[data-site-header-search-submit]',
        searchTextSelector: '[data-field-text]',
        searchInspirationActiveClass: 'site-search-inspiration-active',
        searchCategory: '[data-site-header-search2-category]',
        searchCategoryDropDownSelector: '[data-site-header-search-category-dropdown]',
        searchCategorySelectedDropDownSelector: '[data-site-header-search-category-selected]',
        filledClass: 'text-area-filled',
        autocompleteCategoryIdDataAttribute: 'autocomplete-category-id',
        initData: null
    });

    this._toggleClearButton = function (query) {
        var searchFieldHasText = (query !== '' && query !== undefined);
        this.select('searchFieldArea').toggleClass(this.attr.filledClass, searchFieldHasText);
    };

    this._searchFieldClear = function () {
        var input = this.select('searchTextSelector');
        this.select('searchFieldArea').removeClass('text-area-filled');
        input.val('');
        input.focus();
    };

    this._searchTextBlur = function () {
        selectedShopUrl = '';
        this.trigger(document, 'ui:site-search:on-search-field-blur');
        this._wasFocused = true;
        setTimeout(function () {
            this._wasFocused = false;
        }.bind(this), 100);
    };

    this._searchTextFocus = function () {
        var payload = { 'query': this._query() };
        this.trigger(document, 'ui:site-search:on-search-field-focusin', payload);
    };

    this._onSearchClick = function () {
        var searchVisible = this._searchFieldVisible,
            pageName = this._initData.hasOwnProperty('pageName') ? this._initData.pageName : 'unknown';

        if (!this._searchFieldVisibleByDefault) {
            this._toggleSearch();
        }

        this.trigger('analytics:track-event', {
            category: 'Header',
            action: 'Navigation',
            label: 'Search icon click | searchVisible: ' + searchVisible + ' | pageName: ' + pageName
        });

        this._tryFocusSearchField();
    };

    this._tryFocusSearchField = function () {
        if (this._searchFieldVisible && !this._wasFocused) {
            this.select('searchTextSelector').focus();
        }
    };

    this._toggleSearch = function (visible) {
        this._searchFieldVisible = typeof (visible) === 'undefined' ? !this._searchFieldVisible : visible;
        this.$node.toggleClass('visible', this._searchFieldVisible);

        this.trigger(document, 'ui:site-header:search-visiblity-changed', {
            visible: this._searchFieldVisible
        });
    };

    this._search = function (evt, opts) {
        if (evt.which !== KEYCODE_ENTER) {
            selectedShopUrl = '';
        }

        if (this._isEvtValidSubmitEvent(evt) === false) {
            return;
        }

        evt.preventDefault();
        var searchValue = (this._getSearchQuery(opts) || '').trim();

        if (searchValue.length === 1) {
            return;
        }

        this._handleValidSearch(searchValue);
    };

    this._handleValidSearch = function (searchValue) {
        this.trigger(document, 'ui:site-search:on-search-submit');
        this.trigger(document, 'ui:site-search:on-search', {
            query: searchValue,
            categoryId: this._getSelectedCategoryId()
        });

        if (this._shopIsSelected()) {
            this._handleShopSearch();
        } else if (searchValue.length === 0) {
            this._handleEmptySearch();
        } else {
            this._handleSearch(searchValue);
        }

        selectedShopUrl = '';
        this.select('searchTextSelector').blur();
    };

    this._shopIsSelected = function () {
        return selectedShopUrl && selectedShopUrl.length > 0;
    };

    this._handleSearch = function (searchValue) {
        this.trigger(document, 'ui:navigate', { href: this._createSearchUrl(searchValue) });
    };

    this._handleShopSearch = function () {
        this.trigger(document, 'ui:site-search:on-search-submit');
        this.trigger(document, 'ui:navigate', { href: selectedShopUrl });
    };

    this._handleEmptySearch = function () {
        var keptQueryString = this._getExistingQueryString();
        var selected = this._getSelectedCategory();
        if (selected) {
            var url = selected.data('site-header-search-category-url');

            if (this._useSticky()) {
                url = url + '?' + keptQueryString;
            }

            this.trigger(document, 'ui:navigate', { href: url });
        }
    };

    this._getSelectedCategoryId = function () {
        var categoryDropDown = this.select('searchCategoryDropDownSelector');
        var categoryId = categoryDropDown.data(this.attr.autocompleteCategoryIdDataAttribute);

        return categoryId > 0 ? categoryId : categoryDropDown.val() || 0;
    };

    this._getQueryStringFromInitData = function () {
        if (this._initData.searchUrl && this._initData.searchUrl.indexOf('?') > -1) {
            return this._initData.searchUrl.split('?')[1];
        }
        return '';
    };

    this._getExistingQueryString = function () {
        var query = this._getQueryStringFromInitData(),
            queryVars = (query.length > 0 && query.indexOf('&') > -1) ? query.split('&') : [],
            pair,
            keepTheseParams = [],
            keptQueryString = '';

        var dontKeepTheseParams = ['q', 'categoryId', 'paging', 'spage'];

        queryVars.forEach(function (queryVar) {
            pair = queryVar.split('=');
            if (dontKeepTheseParams.indexOf(pair[0]) < 0) {
                keepTheseParams.push(pair[0] + '=' + pair[1]);
            }
        });

        if (keepTheseParams) {
            keptQueryString = keepTheseParams.join('&');
        }

        return keptQueryString;
    };

    this._createSearchUrl = function (searchValue) {
        var keptQueryString = this._getExistingQueryString();

        var baseUrl = '/search?q=' + encodeURIComponent(searchValue);
        var categoryId = this._getSelectedCategoryId();

        if (this._useSticky(searchValue)) {
            var url = (categoryId > 0) ? baseUrl + '&categoryId=' + categoryId : baseUrl;
            return (keptQueryString.length > 0) ? url + '&' + keptQueryString : url;
        } else {
            return categoryId > 0 ? baseUrl + '&categoryId=' + categoryId : baseUrl;
        }
    };

    // jshint maxcomplexity:6
    this._useSticky = function (searchValue) {
        var currentQuery = searchValue ? searchValue.toLowerCase() : '',
            lastQuery = this._lastQuery ? this._lastQuery.toLowerCase() : false;

        var isQueryReformulation = (currentQuery.indexOf(lastQuery) === 0 || (lastQuery && lastQuery.indexOf(currentQuery) === 0));

        if (isQueryReformulation === true || this._isStillInShoesWithTags() === true) {
            this._logSticky(currentQuery, lastQuery);
            this._setLastQuery(searchValue);
            return true;
        } else {
            this._setLastQuery(searchValue);
            return false;
        }
    };

    this._isStillInShoesWithTags = function () {
        var shoeCategoryId = 1623,
            currentCategoryId = parseInt(this._getSelectedCategoryId(), 10);

        if ((this._lastQueryCategoryId === shoeCategoryId && currentCategoryId === shoeCategoryId) && this._isTagBasedNavigation() === true) {
            return true;
        }

        return false;
    };

    this._isTagBasedNavigation = function () {
        return ($('[data-tagbased-navigation-filters]').length > 0);
    };

    this._logSticky = function (currentQuery, lastQuery) {
        var action;

        if (currentQuery === lastQuery) {
            action = 'Sticky search - Same query';
        } else {
            action = 'Sticky search - Query reformulation';
        }

        this.trigger(document, 'analytics:track-event', {
            category: 'Search',
            action: action,
            label: currentQuery + ' - ' + lastQuery,
            userTriggered: true
        });
    };

    this._searchTextKeydown = function (evt) {
        var keycode = evt.which;
        if (keycode === KEYCODE_ESC) { // tab or escape
            this._toggleSearch(evt);
        }
        else if (keycode === KEYCODE_DOWN || keycode === KEYCODE_UP) {
            this._searchTextNavigate(evt, keycode);
        }
    };

    this._searchTextNavigate = function (evt, keycode) {
        evt.preventDefault();

        var payload = { arrowKeyDirection: keycode === KEYCODE_UP ? 'UP' : 'DOWN' };
        this.trigger(document, 'ui:site-search:on-navigate', payload);
    };

    this._isEvtValidSubmitEvent = function (evt) {
        if (evt.which === KEYCODE_ENTER || evt.type === 'ui:search-suggestion:on-search' || $(evt.target).attr('data-site-header-search-submit') !== undefined) {
            return true;
        }
        return false;
    };

    this._getSearchQuery = function (opts) {
        if (opts && opts.hasOwnProperty('query')) {
            return this.select('searchTextSelector').val(opts.query).val();
        }
        return this.select('searchTextSelector').val();
    };

    this._getValAsLowerCase = function (text) {
        if (text && text.length > 0) {
            return text.toLowerCase();
        }

        return '';
    };

    this._query = function () {
        return this._stripOutInvalidInputForIIS(this._getValAsLowerCase(this.select('searchTextSelector').val()));
    };

    this._searchTextChanged = function (evt) { // Trigger auto complete on search text change

        if (NAVIGATION_KEY_CODES.indexOf(evt.which) >= 0) {
            return;
        }

        var query = this._query();

        this._toggleClearButton(query);

        this.trigger(document, 'ui:site-search:on-search-field-input', { 'query': this._query() });
    };

    this._stripOutInvalidInputForIIS = function (query) {
        return query.replace(/</g, '').replace(/>/g, '');
    };

    this._userClickedSubmit = function (evt) {
        this._search(evt);
    };

    this._toggleInspiration = function (evt, payload) {
        this.$node.toggleClass(this.attr.searchInspirationActiveClass, payload.show);
    };

    this._handleInitData = function (evt, initData) {
        this._updateSearchTextFromInitData(initData);
        this._updateCategoryFromInitData(initData);
        this._toggleSearch(!!initData.hasSearch);
        this._searchFieldVisibleByDefault = this._searchFieldVisible;
    };

    this._updateCategoryFromInitData = function () {
        this._searchCategoryChanged();
    };

    this._updateSearchTextFromInitData = function (initData) {
        var searchValue = this._getSearchQuery();
        if (initData.searchQuery === null) {
            this.select('searchTextSelector').val('');
            this._toggleClearButton('');
        } else if (initData.searchQuery !== searchValue) {
            this.select('searchTextSelector').val(initData.searchQuery);
            this._toggleClearButton(initData.searchQuery);
        }
    };

    this._trackSearchCategoryChanges = function (evt, selectedValue, selectedText) {
        if (evt && evt.type === 'change' && selectedText && selectedValue && selectedValue.toString() !== '0') {
            this.trigger('analytics:track-event', {
                category: 'Search box',
                action: 'SelectCategory',
                label: 'Category: ' + selectedText + ' | CategoryID: ' + selectedValue
            });
        }
    };

    this._searchCategoryChanged = function (evt) {
        var selected = this._getSelectedCategory();

        if (selected && selected.length > 0) {
            var selectedValue = selected.val();
            var selectedText = selected.text();
            this.trigger(document, 'ui:site-search:after-category-change', { categoryId: selectedValue });
            this.select('searchCategorySelectedDropDownSelector').text(selectedText);
            this.select('searchTextSelector').attr('placeholder', selected.data('site-header-search-category-placeholder').trim());
            this._trackSearchCategoryChanges(evt, selectedValue, selectedText);
        }
    };

    this._getSelectedCategory = function () {
        return this.select('searchCategoryDropDownSelector').find('option:selected');
    };

    this._updateSearchQueryFromAutocomplete = function (evt, payload) {
        this.select('searchTextSelector').val(payload.query);

        // Save the categoryId from the auto complete as a data attribute, since the category might not exist in the select drop down
        this.select('searchCategoryDropDownSelector').data(this.attr.autocompleteCategoryIdDataAttribute, payload.categoryId);
        selectedShopUrl = payload.shopUrl;
    };

    this._setLastQuery = function (query) {
        if (query) {
            this._lastQuery = query;
        } else if (this._initData.searchQuery) {
            this._lastQuery = this._initData.searchQuery;
        }

        this._lastQueryCategoryId = parseInt(this._getSelectedCategoryId(), 10);
    };

    this._searchCategoryFocused = function (evt) {
        switch (evt.type) {
            case 'focusout':
                this.select('searchCategory').removeClass(FORM_ELEMENT_FOCUS)
                break;
            case 'focusin':
                this.select('searchCategory').addClass(FORM_ELEMENT_FOCUS)
                break;
            default:
                break;
        }
    };

    this.after('initialize', function () {
        this._initData = this.attr.initData;

        this._setLastQuery();

        this.on('click', {
            searchFieldClear: this._searchFieldClear,
            searchSubmitButtonSelector: this._userClickedSubmit
        });

        this.on('focusin', { searchTextSelector: this._searchTextFocus });
        this.on('focusout', { searchTextSelector: this._searchTextBlur });
        this.on('keydown', { searchTextSelector: this._searchTextKeydown });
        this.on('keypress', { searchTextSelector: this._search });
        this.on('keyup', { searchTextSelector: this._searchTextChanged });
        this.on('change', { searchCategoryDropDownSelector: this._searchCategoryChanged });
        this.on('focusin', { searchCategoryDropDownSelector: this._searchCategoryFocused });
        this.on('focusout', { searchCategoryDropDownSelector: this._searchCategoryFocused });

        this.on(document, 'ui:search-suggestion:on-autocomplete-select', this._updateSearchQueryFromAutocomplete);
        this.on(document, 'ui:search-suggestion:on-search', this._search);
        this.on(document, 'ui:site-header:on-search-click', this._onSearchClick);
        this.on(document, 'ui:navigation:after-page-change', this._handleInitData);
        this.on(document, 'ui:search-suggestion:on-toggle-inspiration', this._toggleInspiration);

        this._searchFieldVisible = this._searchFieldVisibleByDefault = this.$node.hasClass('visible');
        this._searchCategoryChanged();
        this._handleInitData(null, this._initData);
    });
}

module.exports = defineComponent.component(SiteSearch);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/site-search.js